export const colors = {
  primaryColor:"#1A64AF",
  white: "#ffffff",
  lightWhite :"#acacac",
  blue: "#1a64af",
  green: "#58b647",
  slateGray:"#9C9FA6",
  lightGreen:"#5AB849",
  lightPastelBlue:"#CAE4FF",
  whiteSmoke:"#F5F5F5",
  electricBlue:"#1A64AF",
  darkGrey:"#8B8B8B",
  black:"#000000",
  gunMetalGray:"#828282",
  lightBlueGray:"#AFB1B7",
  whiteSmoke:"#F9F9F9",
  oceanBlue: "#1A64AF",
  teal: "#79D2DE",
  crimson : "#EC6666",
  mango : "#F4BE37",
  limeGreen : "#4EC040",
  magenta : "#EB55A5",
  orange : "#FE996C",
  indigo : "#7A75F8",
  slateBlue: "#615E83",
  slatePurple: "rgba(122, 117, 248, 0.15)",
  darkSearGreen: "rgba(78, 192, 64, 0.15)",
  pumpkin: "#EBA900",
  darkGoldenRod: "rgba(235, 169, 0, 0.15)",
  lightTeal: "#BCFAEA",
  darkTeal: "#02BF90",
  lightPinkishRed: "#F6D9D9",
  darkMaroon : "#B11313",
  lightPurple: "rgba(89, 55, 241, 0.10)",
  mediumPurple : "#5937F1",
  lightPeach : "#FFEBBE",
  salmon : "#E49E00",
  powderBlue : "#D2E9FF",
  lightGray: "#D3D3D3",
  greenishBlue : "rgba(2, 191, 144, 0.20)",
  deepSafron:"#F18F1A",
  royalPurple: "#8737F8",
  lightRoyalPurple: "#9d5ff5",
  turquoise : "#1A9AA7",
  lightBeige : "#FBF4E8",
  lavenderBlue : "#F1EAFF",
  lightCyan : "#E8F5F6",
  darkBlue : "#9385F7",
  lightCoral : "#FE996C",
  emaraldGreen : "#5AC99D",
  // 
  lightMint:'#D8FFED',
  DarkMint:'#12C073',
  turquoiseGreen:"#06EC80"
};
